import { render, staticRenderFns } from "./AddRankData.vue?vue&type=template&id=220c4df1&scoped=true&"
import script from "./AddRankData.vue?vue&type=script&lang=js&"
export * from "./AddRankData.vue?vue&type=script&lang=js&"
import style0 from "./AddRankData.vue?vue&type=style&index=0&id=220c4df1&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220c4df1",
  null
  
)

export default component.exports